<template>
<div>
<mt-header :title="title" :fixed="true" v-show="!mydata.header&&mydata.userheader">
  <mt-button icon="back" slot="left" @click="doback()"></mt-button>
  <mt-button slot="right" v-show="showright"> + </mt-button>
</mt-header>
	<router-view @setTitle="setTitle" @rshow="rshow" @back="cback"></router-view>
</div>	
</template>

<style scoped>


</style>

<script>

export default {
  data(){
  	return {
      mydata:mydata,
      title:"",
      doback:fun.doback,
      showright:false,
      fn:"",
  	}
  },	
  created:function(){
  	this.init();
  },
  watch:{
    "$route":"init"
  },
  methods:{
    init:function(){
        mydata.userheader=true;
        var path=this.$route.path;
        if(path=="/user/index"){
            mydata.back=false;
            mydata.header=true;
        }else{
            mydata.back=true;
            mydata.header=false;
        }
    },
    setTitle:function(t){
      this.title=t;
    },
    cback:function(fn){
        this.fn=fn;
    },
    rshow:function(t){
      this.showright=t;
    }
  }
}	
</script>


// WEBPACK FOOTER //
// src/components/user/zz.vue